import React from 'react';
import { Heart, Target, Users } from 'lucide-react';
import FadeInSection from '../components/FadeInSection';
import PageBanner from '../components/PageBanner';
import { useCms } from '../context/CmsContext';

const OverOns = () => {
  const { t, img, team } = useCms();
  return (
    <div>
      <PageBanner
        image={img('banner.overons')}
        title={t('overons.hero_title', 'Over Cocktailmannetje')}
        subtitle={t('overons.hero_subtitle', 'Passie voor cocktails, oog voor detail en een missie om elk evenement onvergetelijk te maken')}
      />

      {/* Ons Verhaal */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <FadeInSection>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="font-serif-display text-5xl mb-6 text-[#13498f]">
                {t('overons.story_title', 'Ons Verhaal')}
              </h2>
              <div className="space-y-4 text-lg text-gray-700 font-light">
                <p>{t('overons.story_p1', '')}</p>
                <p>{t('overons.story_p2', '')}</p>
                <p>{t('overons.story_p3', '')}</p>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-summer">
              <img
                src="https://images.unsplash.com/photo-1717501787981-d5f28eb2df5f?w=800&q=80"
                alt="Cocktailmannetje team"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </FadeInSection>
      </section>

      {/* Kernwaarden */}
      <section className="bg-[#F5E6D3] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeInSection>
            <h2 className="font-serif-display text-5xl text-center mb-12 text-[#13498f]">
              {t('overons.values_title', 'Onze Kernwaarden')}
            </h2>
          </FadeInSection>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-summer text-center">
              <div className="bg-cm-primary w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="text-white" size={32} />
              </div>
              <h3 className="font-serif-display text-2xl mb-3 text-[#13498f]">Kwaliteit</h3>
              <p className="text-gray-700 font-light">
                Alleen de beste ingrediënten en professionele apparatuur voor perfecte cocktails
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-summer text-center">
              <div className="bg-cm-primary w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="text-white" size={32} />
              </div>
              <h3 className="font-serif-display text-2xl mb-3 text-[#13498f]">Gastvrijheid</h3>
              <p className="text-gray-700 font-light">
                Vriendelijke service met persoonlijke aandacht voor elke gast
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-summer text-center">
              <div className="bg-cm-primary w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">★</span>
              </div>
              <h3 className="font-serif-display text-2xl mb-3 text-[#13498f]">Sfeer</h3>
              <p className="text-gray-700 font-light">
                Luxe zomerse uitstraling met Ibiza/Miami beach club vibes
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-summer text-center">
              <div className="bg-cm-primary w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="text-white" size={32} />
              </div>
              <h3 className="font-serif-display text-2xl mb-3 text-[#13498f]">Professionaliteit</h3>
              <p className="text-gray-700 font-light">
                Betrouwbaar, punctueel en altijd perfect verzorgd
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ons Team */}
      {team && team.length > 0 && team.some((m) => m.name || m.photo) && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <FadeInSection>
            <div className="text-center mb-14">
              <p className="uppercase tracking-[0.3em] text-xs text-cm-primary mb-4">De Mensen Erachter</p>
              <h2 className="font-serif-display text-5xl text-[#13498f]">Ons Team</h2>
            </div>
          </FadeInSection>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {team.map((member, idx) => (
              <FadeInSection key={idx} delay={idx * 100}>
                <div className="bg-white rounded-2xl shadow-elegant overflow-hidden border border-gray-100 h-full">
                  <div
                    className="h-72 bg-cm-primary bg-cover bg-center"
                    style={member.photo ? { backgroundImage: `url("${member.photo}")` } : {}}
                  />
                  <div className="p-6 text-center">
                    <h3 className="font-serif-display text-2xl text-cm-primary mb-1">{member.name || 'Naam'}</h3>
                    {member.role && (
                      <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-3">{member.role}</p>
                    )}
                    {member.bio && (
                      <p className="text-sm text-gray-600 font-light leading-relaxed">{member.bio}</p>
                    )}
                  </div>
                </div>
              </FadeInSection>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default OverOns;
